// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileZipOutlinedSvg from "@ant-design/icons-svg/es/asn/FileZipOutlined";
import AntdIcon from '../components/AntdIcon';

var FileZipOutlined = function FileZipOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileZipOutlinedSvg
  }));
};

FileZipOutlined.displayName = 'FileZipOutlined';
export default React.forwardRef(FileZipOutlined);